<template>
  <div>
  
    <future-alert :end="end" />
    
    <v-row>
      <v-col>
        <Kpis
          :location-ids="locationIds"
          :channels="channels"
          :start="start"
          :end="end"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <RevenueOverTime
          :loading="loading"
          :date-summaries="dateSummaries"
          :channels="channels"
        />
      </v-col>
    </v-row>

  </div>
</template>

<script setup lang="ts">

import { useI18n } from 'vue-i18n'
import { useTitle } from '@vueuse/core'

// components
import FutureAlert from './reports/FutureAlert.vue'
import Kpis from './reports/Kpis.vue'
import RevenueOverTime from './reports/RevenueOverTime.vue'

// misc
import { Temporal } from '@js-temporal/polyfill'
import type { ReportingDateSummaries } from '../../../services/api-clients/ReportingApi'

interface Props {
  loading: boolean
  dateSummaries: ReportingDateSummaries
  locationIds: number[]
  channels: string[]
  start: null | Temporal.PlainDate
  end: null | Temporal.PlainDate
}

withDefaults(defineProps<Props>(), {
  loading: false,
  locationIds: () => [],
  channels: () => [],
})

const { t } = useI18n()
const title = useTitle()
title.value = t('titles.reporting_overview')

</script>
